import type { NavigateFunction } from 'react-router-dom';

let navigate: NavigateFunction | null = null;

interface NavigationHistoryItem {
  path: string;
  timestamp: number;
  state?: any;
}

const navigationHistory: NavigationHistoryItem[] = [];
const MAX_HISTORY_LENGTH = 50; // Ограничение размера истории

export const setNavigate = (nav: NavigateFunction) => {
  navigate = nav;
};

export const addToHistory = (path: string, state?: any) => {
  navigationHistory.push({
    path,
    timestamp: Date.now(),
    state,
  });

  if (navigationHistory.length > MAX_HISTORY_LENGTH) {
    navigationHistory.shift();
  }
  // console.log(
  //   '%c[Navigation]%c History updated',
  //   'background: #4CAF50; color: white; padding: 2px 6px; border-radius: 3px; font-weight: bold',
  //   'color: #4CAF50; font-weight: bold',
  //   navigationHistory
  // );
};

export const redirectTo = (
  path: string,
  options?: { replace?: boolean; state?: any }
) => {
  // console.log(
  //   '%c[Navigation]%c → %c' + path,
  //   'background: #2196F3; color: white; padding: 2px 6px; border-radius: 3px; font-weight: bold',
  //   'color: #666',
  //   'color: #2196F3; font-weight: bold',
  //   options
  // );
  if (navigate) {
    navigate(path, options);
  } else {
    console.warn('Navigate not initialized, using window.location');
    window.location.href = path;
  }
};

export const goBack = () => {
  if (navigate) {
    navigate(-1);
  } else {
    window.history.back();
  }
};

export const goForward = () => {
  if (navigate) {
    navigate(1);
  } else {
    window.history.forward();
  }
};

export const getNavigationHistory = (): readonly NavigationHistoryItem[] => {
  return [...navigationHistory];
};

export const clearNavigationHistory = () => {
  navigationHistory.length = 0;
};

export const getPreviousPath = (): string | null => {
  if (navigationHistory.length < 2) return null;
  return navigationHistory[navigationHistory.length - 2].path;
};
